import { render, staticRenderFns } from "./DisplayCompleted.vue?vue&type=template&id=16809299"
import script from "./DisplayCompleted.vue?vue&type=script&lang=js"
export * from "./DisplayCompleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports